/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import { spacing } from "../../../../../../global/emotion";
import type { CardProps } from "../../../../refactor/Card/Card.emotion";
import { Card } from "../../../../refactor/Card/Card.emotion";

const cardStyle: Interpolation = {
  paddingTop: "110%",
};
const infoContainerStyle: Interpolation = {
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  paddingTop: spacing.s,
};
const maskStyle: Interpolation = {
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};

export type NextUpMediumProps = CardProps;

export const NextUpMedium = ({
  centerActions,
  description,
  imgSrc,
  infoContainerCSS,
  maskProps,
  rightActions,
  tag,
  title,
  titleProps,
  ...props
}: NextUpMediumProps) => (
  <Card
    alternativeTitle={title}
    description={description}
    imgSrc={imgSrc}
    infoContainerCSS={[infoContainerStyle, infoContainerCSS]}
    maskCSS={maskStyle}
    maskProps={maskProps}
    centerActions={centerActions}
    rightActions={rightActions}
    tag={tag}
    css={cardStyle}
    {...props}
  />
);
